import React, { useState, useEffect } from "react";
import Calendar from "react-calendar";
import { Grid } from "@mui/material";
import ButtonPolicy from "src/components/Permission/ButtonPolicy";
import "./Checks.css";
import ErrorIcon from '@mui/icons-material/Error';
import {
  Dialog,
  DialogContent,
  DialogActions,
} from "@mui/material";
import {
  useRouteLoaderData,
} from "react-router-dom";
import { getAllAlarms } from "src/apis/tickets";
import { useAlertContext } from "src/hooks/use-alert";
const Checks = () => {

  const alert = useAlertContext();

  const [date, setDate] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [activeDate, setActiveDate] = useState(null);
  const allAlarms = useRouteLoaderData("notifications");
  const [notifications, setNotifications] = useState([]);





  /** fetch alarms function */
  const fetchAlarms = async () => {
    await getAllAlarms().then((res) => {
      if (res && res.length>0) {
        const dateSortedAlarms = res.sort(
          (a, b) => -(new Date(a.date) - new Date(b.date))
        );
      setNotifications(dateSortedAlarms)}
    });
  };


  /**Substituted loader with fetch on load component method */
useEffect(()=>{
  fetchAlarms();

},[])

/**Require refetch or update ticketStatus if ticket update or alarm event  */
useEffect(() => {
  if (alert.alarmPageUpdate) { //causes to refetch all alarms after reception of alarm in socket
    const timeoutId = setTimeout(() => {
      fetchAlarms();
    }, 900); 
   
    alert.setAlarmPageUpdate(false)
  } // fetch new alarms 

  if (alert.ticketUpdate) {
    const newState = notifications.map(obj => {
      // 👇️ if Ticketid of corresponding alarm equals id in event, update actual status property
      if (obj.fatherId === parseInt(alert.ticketUpdate.fatherId)) {
        const index = parseInt(alert.ticketUpdate.status)
        return { ...obj, ticketStatus: index };
      }
      return obj;
    });
    setNotifications(newState);
  } 


}, [alert.alarmPageUpdate, alert.ticketUpdate]);
  useEffect(() => {
    const currentDate = new Date();
    console.log("today is:" + currentDate);

    // Extract the date components (year, month, day)
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed, so add 1
    const day = String(currentDate.getDate()).padStart(2, '0');
  
    // Format the date as a string (e.g., "YYYY-MM-DD")
    const formattedDateToday = `${year}-${month}-${day}`;
    console.log("formattedDateToday:" + formattedDateToday)
   
    const notificationsForDate = notifications.filter(
      (notification) => notification.date.substring(0, 10) === formattedDateToday      
    );
  
    //const newDate = date.substring(0, 10);
    console.log(notificationsForDate);
    setSelectedNotifications(notificationsForDate);
    setDate(date);

  }, [notifications]);



  const [selectedNotifications, setSelectedNotifications] = useState([]);
  const [selectedNotification, setSelectedNotification] = useState(null);


  const handleDateClick = (value) => {
   
    const originalDate = new Date(value);
    // Convert it to the desired format
    const year = originalDate.getUTCFullYear();
    const month = String(originalDate.getUTCMonth() + 1).padStart(2, '0'); // Add 1 to month because months are zero-indexed
    const day = String(originalDate.getUTCDate()+1).padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;
    console.log(formattedDate); 
   // console.log(notifications[1].date.substring(0, 10));

    const notificationsForDate = notifications.filter(
      (notification) => notification.date.substring(0, 10) === formattedDate
      
    );
  
   
    //const newDate = date.substring(0, 10);
    console.log(notificationsForDate);
    setSelectedNotifications(notificationsForDate);
    setDate(date);
    // setSelectedDate(dateStr);
  };



  const tileContent = ({ date }) => {
    const originalDate = new Date(date);
    // Convert it to the desired format
    const year = originalDate.getUTCFullYear();
    const month = String(originalDate.getUTCMonth() + 1).padStart(2, '0'); // Add 1 to month because months are zero-indexed
    const day = String(originalDate.getUTCDate()+1).padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;
   
    const notificationsForDate = notifications.filter(
      (notification) => notification.date.substring(0, 10) === formattedDate
    );
    if (notificationsForDate.length > 0) {
      return <div className="notification-dot"><ErrorIcon /></div>;
    } else {
      return null;
    }
  };


  const handleViewFaultsClick = (notification) => {
    setSelectedNotification(notification);
    setDialogOpen(true);
  };
/* Decide color for button */
const obtainColor = (impactType, ticketStatus) => {
  let key =""
  if(impactType==="ALARM"){
   key = `${impactType.toLowerCase()}-${ticketStatus}`
  }
  if((impactType==="WARNING") && ticketStatus<4){
    key="warning"
   } 
   else if((impactType==="WARNING") && ticketStatus===4){
    key="closed"
   }
   if((impactType==="AI") && ticketStatus<4){
    key="ai"
   } 
   else if((impactType==="AI") && ticketStatus===4){
    key="closed"
   }
  switch (key) {
    case 'alarm-1':
    case 'alarm-2':
      return 'red';
    case 'alarm-3':
      return 'yellow';
    case 'alarm-4':
      return 'green';
    case 'warning':
      return "orange"
    case 'ai':
        return "purple" 
    case 'closed':
      return "green"
    default:
      return '';
  }
};
  return (
    <>
      <Grid className="calendar-and-notifications" container lg={12} md={12} xs={12}>
                <Grid item lg={6} sm={6} xs={12} height={"100%"}>
                  <Calendar
                      value={date}
                      onClickDay={(value) => {
                        setActiveDate(value); // Set the clicked date as the active date
                        handleDateClick(value);
                      }}
                      tileContent={tileContent}
                      tileClassName={({ date }) => {
                        if (activeDate && date.toDateString() === activeDate.toDateString()) {
                          return 'active-date';
                        }
                        return null;
                      }}
                    />
                </Grid>
                <Grid item lg={6} sm={6} xs={12} height={"100%"}>
                  <div className="notifications">
                  {selectedNotifications.length > 0 ? (
                    <h3>Notifications for {selectedNotifications[0].date.substring(0, 10)}:</h3>
                    ):
                    (
                      <h3></h3>
                    )}
                    <Grid container justifyContent={"space-around"} paddingX={"20px"}>
                      {selectedNotifications.length > 0 ? (
                        selectedNotifications.map((notification) => (
                          <>
                            <Grid item >
                              <div className="holdd">

                                <div className="notifCard">
  <h3>{notification.itemSnAssociated}</h3>
  <h4>{notification.assetSnAssociated}</h4>
  <ul>
    <>
      <li>
        {new Date(notification.date).toLocaleDateString()} - {new Date(notification.date).toLocaleTimeString()}
      </li>
    </>
  </ul>
  <div className="alertButtonContainer">
    <div className={`${notification.impactType.toLowerCase()}-ticketStatus-${notification.ticketStatus}`}>
    <ButtonPolicy
      onClick={() => handleViewFaultsClick(notification)}
      color={obtainColor(notification.impactType,notification.ticketStatus)}
      variant="contained"
    >
      View Faults
    </ButtonPolicy>
    </div>
  </div>
</div>

                              </div>
                            </Grid>
                          </>
                        ))
                      ) : (
                        <div className="noNotif"><p>No Alarms Present</p></div>
                      )}
                    </Grid>
                  </div>
                </Grid>
      </Grid>
      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
        <DialogContent>
          {selectedNotification && (
            <div>
              <p>{selectedNotification.itemSnAssociated}</p>
              <p>{selectedNotification.assetSnAssociated}</p>
              <p>{selectedNotification.date}</p>
              <p>Severity : {selectedNotification.impactName}</p>
              <p> Handled by operator with mail : {selectedNotification.mnt_operator_email}</p>
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <ButtonPolicy onClick={() => setDialogOpen(false)}>Close</ButtonPolicy>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Checks;
